export default {
  con: 'archsummit',
  year: '2020',
  location: 'shenzhen'
}
